/** Line icons (Remix Icon) for each stage of the grading journey, shared by every timeline. */
export const STEP_ICONS = {
  quote: 'ri-file-list-3-line',
  payment: 'ri-bank-card-line',
  shipping: 'ri-truck-line',
  received: 'ri-inbox-archive-line',
  grading: 'ri-search-eye-line',
  graded: 'ri-medal-line',
  minted: 'ri-hexagon-line',
  returned: 'ri-arrow-go-back-line',
  done: 'ri-flag-2-line',
}

export const DEFAULT_STEP_ICON = 'ri-circle-line'
